import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import defaultThemes from './themes.js';
import themeConfig from '../../themes.conf.js';
import { themeClassName, generateStylesObject } from './theme-wrapper.utils.js';
import { IS_BROWSER, InjecssContext, CLIENT_ID_NAMESPACE, HCR_VERSION_SUFFIX, cachedInlineCss, appendStyles } from '../../packages/injecss/injecss.js';

function ThemeWrapper(_a) {
  var {
      children,
      theme = 'flix',
      themes = defaultThemes,
      applyToRoot = false
    } = _a,
    rest = __rest(_a, ["children", "theme", "themes", "applyToRoot"]);
  useEffect(() => {
    // only control root class name in the browser
    if (IS_BROWSER && applyToRoot === true) {
      document.documentElement.classList.add(themeClassName(theme));
    }
    return () => {
      if (IS_BROWSER) {
        document.documentElement.classList.remove(themeClassName(theme));
      }
    };
  }, [theme, applyToRoot]);
  const InjecssContextValue = useContext(InjecssContext);
  // merge default and custom theme object,
  // so the default theme is always there even when not provided
  const themeObject = Object.assign(Object.assign({}, defaultThemes), themes);
  const styles = generateStylesObject(themeObject, applyToRoot);
  // adding themes to style element ID,
  // in order to allow for multiple theme wrapper usages on one page with different theme setups
  // so they want override each other
  const componentID = "ThemeWrapper__".concat(applyToRoot ? 'root-' : '').concat(Object.keys(themeObject).join('-')).concat(CLIENT_ID_NAMESPACE).concat(HCR_VERSION_SUFFIX);
  // only add styles to context in an SSR environment
  if (!IS_BROWSER) {
    cachedInlineCss(InjecssContextValue, styles.raw, componentID);
  }
  appendStyles(componentID, styles.raw);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: applyToRoot ? undefined : themeClassName(theme)
  }, rest), children);
}
ThemeWrapper.displayName = 'ThemeWrapper';
ThemeWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(themeConfig.honeycombThemes),
  themes: PropTypes.shape({}) // @todo improve this to be more in line with what we have on TS
};

export { ThemeWrapper, ThemeWrapper as default };
